
// rounting
import BidProjectList from './list/index.vue';
import Add from './add/index.vue';
import Detail from './detail/index.vue';
export default [
  {
    path: 'list',
    name: 'supplyAndDemandList',
    component: BidProjectList,
    meta: {
      title: '供需大厅',
      breadCrumbShowIndexArr: [0]  // 面包屑
    }
  },
  {
    path: 'add',
    name: 'supplyAndDemandAdd',
    component: Add,
    meta: {
      title: '发布',
      breadCrumbShowIndexArr: [0]  // 面包屑
    }
  },
  {
    path: 'detail',
    name: 'demandDetail',
    component: Detail,
    meta: {
      title: '详情',
      breadCrumbShowIndexArr: [0, 1]  // 面包屑
    }
  }
];
